export class ImageModel {
  content: any;
  sizeInBytes: number;
  contentType: any;
  name: string;
  attachmentId?: number;
}
